import { workCategories } from "../../consts/misc";
import useIsMobile from "../../hooks/useIsMobile";
import { Category } from "../../interfaces";
import BarLevel from "../misc/BarLevel";

const WorkCategories = (props: any) => {
  const { isMobile } = useIsMobile();

  const renderLine = (array: Category[]) => {
    return array.map((category: Category, key: number) => {
      const percentage =
        props.model?.work_categories[category.name.toLowerCase()];
      return (
        <div key={key}>
          <span
            className="category-name-value"
            style={{
              margin: isMobile ? "0 auto -8px" : "",
            }}
          >
            <p className="category-name">{category.displayName}</p>
            <p className="category-name">{percentage ? percentage : 0}%</p>
          </span>
          <BarLevel percentage={percentage} barColor={category.barColor} />
        </div>
      );
    });
  };

  const renderFirstLine = renderLine(workCategories.slice(0, 4));
  const renderSecondLine = renderLine(workCategories.slice(4, 8));
  const renderThirdLine = renderLine(workCategories.slice(8, 12));

  return (
    <div
      className="work-categories shadow"
      style={{
        width: isMobile ? "345px" : "",
        height: isMobile ? "660px" : "",
        margin: isMobile ? "0" : "",
        padding: isMobile ? "0" : "",
      }}
    >
      <p
        className="work-categories-title"
        style={{
          margin: isMobile ? "36px 21px" : "",
        }}
      >
        Work's categories
      </p>
      <div
        className="work-categories-lines-wrapper"
        style={{
          margin: isMobile ? "0 21px" : "",
          gap: isMobile ? "12px" : "",
        }}
      >
        <div
          className="work-categories-line-container"
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "12px" : "",
          }}
        >
          {renderFirstLine}
        </div>
        <div
          className="work-categories-line-container"
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "12px" : "",
          }}
        >
          {renderSecondLine}
        </div>
        <div
          className="work-categories-line-container"
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "12px" : "",
          }}
        >
          {renderThirdLine}
        </div>
      </div>
    </div>
  );
};
export default WorkCategories;
